import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Grid } from '@mui/material';
import { Formik } from 'formik';
import { forwardRef, useCallback, useContext, useImperativeHandle, useRef, } from 'react';
import { ReducerContext as UserSettingReducerContext } from '../../hooks/reducer/reducerContext';
import { introEntitlementFormSchemaFunc, } from '../../yup-schemas';
import { EntitlementActionKind, EntitlementExceptionsActionKind, IntroSetupContext, } from '../reducer';
import { EntitlementPageForm } from './EntitlementPageForm';
// eslint-disable-next-line react/display-name
export const EntitlementPage = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handleSubmit() {
            formRef.current.handleSubmit();
        },
        getIsValid() {
            return formRef.current.isValid;
        },
    }));
    const { entitlementExceptionsDispatch, entitlementDispatch, entitlementState, entitlementExceptionsState, } = useContext(IntroSetupContext);
    const { userSettingsState } = useContext(UserSettingReducerContext);
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    const formRef = useRef();
    const handleSubmit = useCallback((values) => {
        if (values.remainingEntitlement === null || values.totalEntitlement === null) {
            return;
        }
        const roundToNearestHalfDay = (n) => Math.round(n * 2) / 2;
        entitlementDispatch({
            type: EntitlementActionKind.ModifyEntitlement,
            payload: {
                remainingEntitlement: roundToNearestHalfDay(values.remainingEntitlement),
                totalEntitlement: roundToNearestHalfDay(values.totalEntitlement),
            },
        });
        entitlementExceptionsDispatch({
            type: EntitlementExceptionsActionKind.ModifyEntitlementExceptions,
            payload: {
                regionCode: values.regionCode,
                countryCode: 'GB',
                bankHolidaysDeducting: values.regionCode !== 'None' ? true : false,
            },
        });
        return undefined;
    }, [entitlementDispatch, entitlementExceptionsDispatch]);
    const handleRegionCodeChange = useCallback((regionCode) => formRef.current.setFieldValue('regionCode', regionCode), []);
    return (_jsx(Box, { sx: { width: '100%', marginTop: '1em' }, children: _jsx(Grid, { container: true, justifyContent: "center", children: _jsx(Formik, { initialValues: {
                    remainingEntitlement: props.initial
                        ? null
                        : entitlementState.remainingEntitlement,
                    totalEntitlement: props.initial ? null : entitlementState.totalEntitlement,
                    regionCode: props.initial ? 'None' : entitlementExceptionsState.regionCode,
                }, validationSchema: introEntitlementFormSchemaFunc(userSettingsState, props.endDate), onSubmit: handleSubmit, validateOnMount: true, innerRef: formRef, children: ({ values }) => (_jsx(EntitlementPageForm, { values: values, regionCodeChange: handleRegionCodeChange })) }) }) }));
});
